import React from 'react';

export default class SlotName extends React.Component {
    static propTypes = {
        match: React.PropTypes.object,
        slot: React.PropTypes.object,
        outcome: React.PropTypes.object,
        sportId: React.PropTypes.number.isRequired,
        gridLocalization: React.PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
    }

    render() {
        const {sportId, slot, outcome} = this.props;

        const match = {
            homeTeam: this.props.match.get('firstTeam'),
            awayTeam: this.props.match.get('secondTeam')
        };

        const slotName = this.props.gridLocalization.getSlotName(sportId, match, slot);
        const outcomeName = this.props.gridLocalization.getOutcomeName(sportId, outcome.toJS(), match);

        return (
            <span className="cell-content">
               {outcomeName || slotName}
            </span>
        );
    }
}



// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/components/slots/SlotName.jsx